import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { DEFAULT_HR_EMAIL } from './constants/form';
import {
  JobApplicationForm,
  JobApplicationFormProps,
} from './JobApplicationForm';

export type JobApplicationStrapiProps = {
  hrEmail?: string;
  role?: string;
};

export function JobApplicationFormStrapi({
  block,
}: BlockComponentModel<JobApplicationStrapiProps>) {
  return <JobApplicationForm {...transformJobApplicationForm(block)} />;
}

export function transformJobApplicationForm(
  block: JobApplicationStrapiProps
): JobApplicationFormProps {
  const { hrEmail, role } = block;

  return {
    job: {
      role: role ?? '',
      hrEmail: hrEmail ?? DEFAULT_HR_EMAIL,
    },
  };
}
